import VariantMediaData from '@/ts/VariantMediaData';
import { VariantDataResponse } from '@/ts/HococoInterfaces';

export default class VariantData {
    public id: number;
    public projectId: number;
    public projectName: string;
    public name: string;
    public area: string;
    public rooms: number;
    public description: string;
    public media: VariantMediaData[] = [];
    public mediaMap: { [index: number]: number } = {};
    public hasFloorPlan: boolean = false;

    constructor(
        id: number,
        projectId: number = null,
        projectName: string = '',
        name: string = '',
        area: string = '',
        rooms: number = null,
        description: string = '',
        hasFloorPlan: boolean = false,
    ) {
        this.id = id;
        this.projectId = projectId;
        this.projectName = projectName;
        this.name = name;
        this.area = area;
        this.rooms = rooms;
        this.description = description;
        this.hasFloorPlan = hasFloorPlan;
    }

    get persisted(): boolean {
        return (this.id !== -1);
    }

    public dataEquals(variant: VariantData): boolean {
        // Check if this object's values are equal to the given object's
        if (
            this.id === variant.id &&
            this.projectId === variant.projectId &&
            this.projectName === variant.projectName &&
            this.name === variant.name &&
            this.area === variant.area &&
            this.rooms === variant.rooms &&
            this.description === variant.description &&
            this.media === variant.media &&
            this.hasFloorPlan === variant.hasFloorPlan
        ) {
            return false;
        }
    }

    public addMedia(mediaData: VariantMediaData) {
        const index = this.media.push(mediaData) - 1;
        this.mediaMap[mediaData.id] = index;
    }

    public removeMedia(mediaDataId: number) {
        this.media[this.mediaMap[mediaDataId]].markForDeletion();
    }

    public cloneData(variant: VariantData) {
        this.projectId = variant.projectId;
        this.projectName = variant.projectName;
        this.name = variant.name;
        this.area = variant.area;
        this.rooms = variant.rooms;
        this.description = variant.description;
        this.media = variant.media;
        this.hasFloorPlan = variant.hasFloorPlan;
    }

    public updateLocalVariantData(variant: VariantDataResponse) {
        this.projectId   = variant.projectId;
        this.projectName = variant.projectName;
        this.name        = variant.name;
        this.area        = variant.area;
        this.rooms       = variant.rooms;
        this.description = variant.description;
    }
}

